import { Stack, styled } from '@mui/material';
import { HEADER_TITLE_CONSTANTS } from '../constants';

/**
 * Desktop View Container
 * Responsive container for desktop layout
 */
export const DesktopContainer = styled(Stack)(({ theme }) => ({
  display: 'none',
  width: '100%',
  flex: 1,
  gap: theme.spacing(HEADER_TITLE_CONSTANTS.DESKTOP_GAP),
  alignItems: 'center',
  flexDirection: 'row',

  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

/**
 * Mobile View Container
 * Responsive container for mobile layout
 */
export const MobileContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(HEADER_TITLE_CONSTANTS.MOBILE_GAP),
  alignItems: 'flex-start',

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

/**
 * Desktop Content Container
 * Contains the main content area in desktop view
 */
export const DesktopContentContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  flex: 1,
  alignItems: 'center',
  gap: theme.spacing(HEADER_TITLE_CONSTANTS.DESKTOP_CONTENT_GAP),
}));

/**
 * Mobile Tags Container
 * Contains tags in mobile view
 */
export const MobileTagsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(HEADER_TITLE_CONSTANTS.MOBILE_TAGS_GAP),
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

/**
 * Status Tag Wrapper
 * Wrapper for status tag with tooltip support
 */
export const StatusTagWrapper = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
});
